module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAFBJREFUSA1jYCARGBsb/wdhErUxMJGqgVz1oxaRG3KjcUR2yI0G3RAIOkZyyi1y/EW3Iohkx42W3rAgo1scjVoEC3KS6dGgIznIYBqGX9ABAIVeCCjL+Z13AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plus.png
// module id = IOS/
// module chunks = 1